export default [
  {
    path: '/onlendings',
    name: 'OnlendingsList',
    component: () => import('pages/onlendings/OnlendingsList.vue')
  }
]
